<template>
  <section>
    <div class="grid gap-4 lg:grid-cols-3 md:grid-cols-2">
      <div v-for="(d, index) in data" :key="d.id">
        <div
          class="shadow p-2 rounded ring-1 ring-gray-300 hover:shadow"
          @mouseover="handleMouseOver(index)"
          @mouseleave="handleMouseLeave(index)"
        >
          <div
            class="float-right"
            :class="{
              visible:
                iconsToShowOnCard &&
                iconsToShowOnCard.length &&
                iconsToShowOnCard[index],
              invisible: !iconsToShowOnCard[index],
            }"
          >
            <button
              type="button"
              class="px-2"
              @click="$emit('pencil_id', d.id)"
            >
              <Pencil />
            </button>
            <button type="button" class="px-2" @click="$emit('trash_id', d.id)">
              <Trash />
            </button>
          </div>
          <img
            :src="baseUrlSrc(d.thumbnail_url)"
            alt="..."
            class="rounded md:w-72 lg:h-40 md:h-32 w-full h-56"
            @error="defaultImage"
          />
          <div class="flex items-center justify-between mt-2">
            <h5 class="capitalize">{{ d.title }}</h5>
            <span>${{ d.cost }}</span>
          </div>
        </div>
      </div>
      <p v-if="data.length == 0">No data found.</p>
    </div>
  </section>
</template>

<script>
import { Pencil, Trash } from "@/components/icons";
export default {
  components: {
    Pencil,
    Trash,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      iconsToShowOnCard: [],
    };
  },
  methods: {
    handleMouseOver(index) {
      const tempIconsToShowOnCard = [...this.iconsToShowOnCard];
      tempIconsToShowOnCard[index] = true;
      this.iconsToShowOnCard = tempIconsToShowOnCard;
    },
    handleMouseLeave(index) {
      const tempIconsToShowOnCard = [...this.iconsToShowOnCard];
      tempIconsToShowOnCard[index] = false;
      this.iconsToShowOnCard = tempIconsToShowOnCard;
    },
  },
};
</script>
